import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const MOD = () => {
  return (
    <CardSection id="MOD" title="MOD">
      <Paragraph>숫자를 제수로 나눈 나머지를 반환합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>MOD(NUMBER, DIVISOR)</Paragraph>
        <Ul>
          <Li>
            <b>NUMBER</b>는 실수입니다.
          </Li>
          <Li>
            <b>DIVISOR</b>는 실수입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>MOD(`Column`, 3)</Paragraph>
        <Img src="computeMod" />
      </ListSection>
    </CardSection>
  );
};
